export default {
  userManagement: {
    userSearchForm: {
      date: '',
      tel: '',
      nickname: '',
      source: 0,
      loginState: 2,
      telState: 2,
      adminEnterpriseMobile: '',
    },
    sourceList: [{
        areaName: '全部',
        areaId: 0
      },
      {
        areaName: '线下',
        areaId: 1
      },
      {
        areaName: 'APP',
        areaId: 2
      },
      {
        areaName: '小程序',
        areaId: 3
      }
    ],
    stateList: [{
        areaName: '全部',
        areaId: 2
      },
      {
        areaName: '是',
        areaId: 1
      },
      {
        areaName: '否',
        areaId: 0
      }
    ],
    totalList: [],

    pageManagement: {
      page: 1,
      size: 10,
      total: 0,
    },

    // pageManagementA: {
    //   page: 1,
    //   size: 10,
    //   total: 0,
    // },
    number: '',

    relationList:[''],
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/UserManagement/state.js